import { render, staticRenderFns } from "./ResourceTOC.vue?vue&type=template&id=6b39312e"
import script from "./ResourceTOC.vue?vue&type=script&lang=js"
export * from "./ResourceTOC.vue?vue&type=script&lang=js"
import style0 from "./ResourceTOC.vue?vue&type=style&index=0&id=6b39312e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports